import React from 'react';
import { Button } from '../ui/Button';
import { useMetaPixel } from '../../hooks/useMetaPixel';
export function StickyBar() {
  const {
    trackAddToCart
  } = useMetaPixel();
  const checkoutUrl = 'https://krove.lat//cart/40641678344321:1';
  const handleBuy = () => {
    trackAddToCart();
    window.location.href = checkoutUrl;
  };
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 p-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 md:hidden" data-id="element-194">
      <div className="flex items-center justify-between gap-4" data-id="element-195">
        <div className="flex flex-col" data-id="element-196">
          <span className="text-xs text-stone-500 line-through" data-id="element-197">80.000</span>
          <span className="font-bold text-stone-900 text-lg" data-id="element-198">23.999 COP</span>
        </div>
        <Button onClick={handleBuy} className="flex-1 shadow-md" data-id="element-199">
          Comprar Ahora
        </Button>
      </div>
    </div>;
}